import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import "../dossier-styles.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import {
    DossierCreationContext,
    LayoutBarContext,
    CustomModalContext,
} from "../../../../contexts";
import DropDown from "../../../UIElements/DropDown";
import CustomButton from "../../../UIElements/CustomButton";
import "../../../components-styles.scss";
//import CustomCheckBox from "../../../UIElements/CustomCheckBox";
import HeaderNewDossier from "./HeaderNewDossier";
import Dossier from "../Dossier";
import { getReferenciels, createNewDossier } from "../../../../services";
import { useLocalStorage } from "../../../../hooks";
import { Referentiel, Session } from "../../../../types";
import { sessionStorageKey } from "../../../../consts";
import CgvModalContent from "./CgvModalContent";
import Home from "../../../ClientSpace/Home/Home";
import { cloneObject, extractNumber, scrollToTop } from "../../../../helpers";

type NewDossierPropsType = {
    topLevelRefCode?: {
        refCodeNumber: number;
        finalized: boolean;
    };
};

const validationSchema = yup.object({
    referentielId: yup.number().required(`Veuillez choisir un niveau`),
    // cgv: yup
    //     .boolean()
    //     .oneOf([true], "Veuillez accepter d'abord les CGV, pour continer."),
});

export default function NewDossier(props?: NewDossierPropsType) {
    const { topLevelRefCode } = props || {};

    const { updateDossierCreationForm, ...dossierCreationForm } = useContext(
        DossierCreationContext
    );
    const { updateContent } = useContext(LayoutBarContext);
    const [referentielOptions, setReferentielOptions] = useState<Referentiel[]>(
        []
    );

    const { updateModal, updateIsCustomModalActive } =
        useContext(CustomModalContext);

    const [cgv, setCgvResponse] = useState<boolean>(false);

    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser },
    } = session;

    //const cgv = watch("cgv");

    const referencielDropDownOptions: Referentiel[] = useMemo(() => {
        if (topLevelRefCode) {
            const newReferencielDropDownOptions = cloneObject(
                referentielOptions
            ).filter((r: any) => {
                // excludeReferencielCodes.includes(r.code)
                if (topLevelRefCode.finalized) {
                    return (
                        extractNumber(r.code) > topLevelRefCode.refCodeNumber
                    );
                }
                return extractNumber(r.code) >= topLevelRefCode.refCodeNumber;
            });
            return newReferencielDropDownOptions;
        }
        return referentielOptions;
    }, [referentielOptions, topLevelRefCode?.refCodeNumber, cgv]);

    const {
        setValue,
        handleSubmit,
        formState: { errors },
        control,
        //watch,
    } = useForm({
        defaultValues: {
            referentielId: referencielDropDownOptions[0]?.id,
        },
        resolver: yupResolver(validationSchema),
    });

    const onSubmit = async (data: any) => {
        const selectedReferentiel = referencielDropDownOptions.find(
            (ref) => ref.id === data.referentielId
        );

        const newDossierBody = {
            creatorUser: currentUser.id,
            establishment: currentUser.establishment,
            referenciel: selectedReferentiel?.id ?? null,
        };

        const creatingNewDossierRes = await createNewDossier(newDossierBody);

        if (!creatingNewDossierRes.detail) {
            const { dossier } = dossierCreationForm;
            const newDossier = {
                ...dossier,
                ...newDossierBody,
            };
            updateDossierCreationForm({
                ...dossierCreationForm,
                referentiel: selectedReferentiel,
                dossier: newDossier,
            });
            updateContent(<Dossier dossierId={creatingNewDossierRes.id} />);
        }
    };

    const handleAccpectCgv = useCallback(() => {
        setCgvResponse(true);
        updateIsCustomModalActive(false);
    }, [cgv]);

    const handleRejectCgv = useCallback(() => {
        setCgvResponse(false);
        updateContent(<Home />);
        updateIsCustomModalActive(false);
    }, [cgv]);

    useEffect(() => {
        (async () => {
            if (cgv) {
                const refsRes = await getReferenciels();
                if (!refsRes.detail) {
                    setReferentielOptions(refsRes.filter((r: any) => r.active));
                    scrollToTop();
                }
            }
        })();
    }, [cgv]);

    useEffect(() => {
        updateModal({
            content: (
                <CgvModalContent
                    acceptCgv={handleAccpectCgv}
                    rejectCgv={handleRejectCgv}
                />
            ),
            // title: "",
            sx: {
                width: "100%",
                paper: {
                    //width: "100%",
                    padding: 0,
                },
            },
            disableBackdropClick: true,
        });
        updateIsCustomModalActive(true);
    }, []);

    useEffect(() => {
        if (referencielDropDownOptions.length) {
            setValue("referentielId", referencielDropDownOptions[0]?.id);
        }
    }, [referencielDropDownOptions]);

    return (
        <>
            <header className="dossier-header">
                <Box
                    sx={{
                        marginLeft: "3rem",
                        marginTop: "5vh",
                        marginRight: "1.5rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: "2.28rem",
                        "@media (max-width:1024px)": {
                            marginLeft: "1.5rem",
                        },
                    }}
                >
                    <HeaderNewDossier back={() => {}} />
                </Box>
            </header>
            <main className="layout-body" style={{ overflow: "hidden" }}>
                {cgv && referencielDropDownOptions.length ? (
                    <Box
                        sx={{
                            marginLeft: "3rem",
                            marginTop: "5vh",
                            marginRight: "1.5rem",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "1.5rem",
                            marginBottom: "4vh",
                            // width: "100%",
                            width: "29.5rem",
                            "@media (max-width:1024px)": {
                                marginLeft: "1.5rem",
                            },
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",

                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "2.5rem",
                            }}
                        >
                            <Typography
                                sx={{
                                    alignSelf: "stretch",
                                    color: "#023",
                                    fontFamily: "Roboto",
                                    fontSize: "1.25rem",
                                    fontQtyle: "normal",
                                    fontWeight: 700,
                                    lineHeight: "normal",
                                }}
                            >
                                Pour quelle année voulez-vous créer votre
                                qualification
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "0.5rem",
                                alignSelf: "stretch",
                            }}
                        >
                            <form
                                onSubmit={handleSubmit(onSubmit)}
                                className="signup-form"
                            >
                                <Controller
                                    name="referentielId"
                                    control={control}
                                    render={({ field: { ref, ...others } }) => {
                                        return (
                                            <DropDown
                                                items={
                                                    referencielDropDownOptions
                                                }
                                                defaultValue={
                                                    referencielDropDownOptions[0]
                                                        ?.id
                                                        ? referencielDropDownOptions[0]
                                                              ?.id
                                                        : ""
                                                }
                                                placeholder="Niveau"
                                                inputlabel={"Niveau *"}
                                                sublabel={
                                                    "Permet d’indiquer sur quel référentiel se base votre dossier de qualification"
                                                }
                                                {...others}
                                                errortext={
                                                    errors?.referentielId
                                                        ?.message
                                                }
                                            />
                                        );
                                    }}
                                />
                                {/* <Controller
                                name={"cgv"}
                                control={control}
                                render={({ field: { ref, ...others } }) => (
                                    <CustomCheckBox
                                        label="CGV Lorem ipsum dolor sit amet consectetur. Facilisi in ridiculus pellentesque massa elementum mauris sed lectus adipiscing. Enim purus ultricies nulla nisl non malesuada pulvinar."
                                        {...others}
                                        checked={cgv}
                                        customlabelsx={{
                                            flex: "1 0 0",
                                            color: "#000",
                                            fontFamily: "Roboto",
                                            fontSize: "0.75rem",
                                            fontStyle: "normal",
                                            fontWeight: 400,
                                            lineHeight: "130%",
                                        }}
                                        errortext={errors?.cgv?.message ?? ""}
                                    />
                                )}
                            /> */}

                                <CustomButton
                                    type="submit"
                                    label="Créer mon dossier"
                                    customsx={{
                                        margin: "none",
                                        top: "28px",

                                        "@media (max-width:1024px)": {
                                            width: "100%",
                                        },
                                    }}
                                />
                            </form>
                        </Box>
                    </Box>
                ) : null}
            </main>
        </>
    );
}
